import React, { useEffect, useState } from 'react';
import { Button, Checkbox, Col, DatePicker, Flex, Form, Input, InputNumber, Row, Select, Space, Table, Tabs, Tag, Tooltip, message } from 'antd';
import { Link, useLoaderData, useNavigate, useOutletContext, useParams } from 'react-router-dom';
import { FaCloudArrowUp } from 'react-icons/fa6';
import { Badge } from 'flowbite-react';
import dayjs from 'dayjs';
import StatusComponent from '../../globalComponents/StatusComponent';
import { quotationProductColumns, poColumns, optionalColumns } from '../utils/tableColumns';
import EditableTable from '../../globalComponents/EditableTable';
import EventEmitter from '../../utils/eventEmitter';
import SmartButton from '../../globalComponents/SmartButton';
import { TbTruckDelivery } from "react-icons/tb";
import useSalesOrderAPI from '../apis/salesOrderAPI';


const shipPolicy = [
  { value: '', label: '' },
  { value: 'asap', label: 'As soon as possible' }
]


const SalesOrderChanges = () => {
  const [form] = Form.useForm();
  const { success, error, CustomBreadcrumb } = useOutletContext();
  const { products, contacts, teams, salesOrder, routes } = useLoaderData();
  salesOrder['delivery_date'] = salesOrder.delivery_date ? dayjs(salesOrder['delivery_date'], 'YYYY-MM-DD HH:mm') : '';
  // salesOrder['effective_date'] = salesOrder.effective_date ? dayjs(salesOrder['effective_date'], 'YYYY-MM-DD HH:mm') : '';
  // salesOrder['expiration_date'] = salesOrder.expiration_date ? dayjs(salesOrder['expiration_date'], 'YYYY-MM-DD HH:mm') : '';
  const params = useParams();
  const navigate = useNavigate();
  const { create, update, confirm, removeProductLine, removeOptionalLine } = useSalesOrderAPI();
  const [productQuotations, setProductQuotations] = useState(salesOrder.number ? salesOrder.orderlines : []);
  const [taxes, setTaxes] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [optionalProducts, setOptionalProducts] = useState(salesOrder.number ? salesOrder.optionals :[]);


  const handleSubmit = async () => {
    let data = form.getFieldsValue();
    data['delivery_date'] = new Date(data.delivery_date);
    data['orderlines'] = productQuotations;
    data['optionals'] = optionalProducts;
    data['tax_total_price'] = form.getFieldValue('tax_total_price');
    create(data, success);
    // console.log(data)
  }


  const confirmOrder = async () => {
    try {
      let data = form.getFieldsValue();
      data['delivery_date'] = new Date(data.delivery_date);
      data['id'] = salesOrder.id;
      data['orderlines'] = productQuotations;
      data['optionals'] = optionalProducts;
      setIsLoading(true);
      await confirm(salesOrder.number, data);
      setIsLoading(false);
    } catch (err) {
      console.log(err);
      setIsLoading(false);
    }
  }


  useEffect(() => {
    EventEmitter.subscribe('sales_reponse', data => {
      // navigate('/sales/orders/'+data.replaceAll('/', '-'));
    });

    EventEmitter.subscribe('purchase_order_confirmed', data => {

      navigate('/sales/orders/' + data.replaceAll('/', '-'));
    })

    EventEmitter.subscribe('tax_total_price', data => {
      const total = data.reduce((prev, current) => (current.amount + prev), 0);
      form.setFieldValue('tax_total_price', total);
    });


    return () => {
      EventEmitter.unsubscribe('sales_reponse');
      EventEmitter.unsubscribe('tax_total_price');
      EventEmitter.unsubscribe('purchase_order_confirmed');
    }
  }, []);


  // useEffect(() => {
  //   fetch('http://localhost:7900/taxes/all/sales-taxes', {
  //     method: 'GET',
  //     credentials: 'include'
  //   })
  //   .then(res => res.json()) 
  //   .then(res => setTaxes(res))
  //   .catch(err => console.log(err))
  // },[]) 

  const addLine = () => {
    let array = [...productQuotations];
    let obj = {
      key: productQuotations.length,
      product_id: '',
      description: ' ',
      quantity: 1,
      packaging_quantity: 0,
      packaging_id: '',
      price: 0,
      invoiced_quantity: 0,
      taxes: [],
      delivered_quantity: 0,
      subtotal: 0
    };
    if (salesOrder.status !== 'sales_order') {
      delete obj.invoiced_quantity;
      delete obj.delivered_quantity;
      // delete obj.received_quantity_subtotal;
    }
    array.push(obj);
    setProductQuotations(array);

  };

  const addOptionalProducts = () => {
    let array = [...optionalProducts];
    let obj = {
      key: optionalProducts.length,
      product_id: '',
      description: ' ',
      quantity: 1,
      price: 0,
    };
    array.push(obj);
    setOptionalProducts(array);

  };

  
  const receiveProducts = () => {
    navigate(`/sales/orders/${params.action}/transfers`);
  }

  return (
    <div className='container mx-auto' style={{ maxWidth: '1200px' }}>
      <div>
        <div className='flex'>
          <h3 className='font-bold'>
            <CustomBreadcrumb />
            {/* <Link to={'/sales/orders'} className='whitespace-nowrap hover:underline text-sky-600 dark:text-white'>Purchase Orders</Link> / {params.action} */}
          </h3>
          <Tooltip title={'save manually'} placement='rightBottom' className='ms-1'>
            <Button onClick={handleSubmit} type='text' htmlType='button'
              disabled={salesOrder.number ? true : false}
              className='border-0 bg-transparent focus:bg-transparent'
              icon={<FaCloudArrowUp />}
            />
          </Tooltip>
        </div>
        {salesOrder.number &&
          <div className='flex justify-between bg-white'>
            <Flex wrap='wrap' align='center' gap={'small'} style={{ maxWidth: '70%' }}>
              {salesOrder.status === 'quotation' &&
                <>
                  <Button size='small' loading={isLoading} disabled={isLoading} type='primary' className='font-semibold bg-[#189aa0] hover-btn' onClick={confirmOrder}>CONFIRM ORDER</Button>
                  <Button size='small' type='text' className='font-semibold text-[#189aa0]'>CANCEL</Button>
                </>
              }
              <>
                {salesOrder.status === 'sales_order' &&
                  <Button size='small' type='primary' className='font-semibold bg-[#189aa0] hover-btn' onClick={receiveProducts}>CREATE INVOICE</Button>}
                {(salesOrder.status === 'received') && <Button size='small' type='text' className='font-semibold bg-[#189aa0]'>CREATE BILL</Button>}
              </>
            </Flex>
            <StatusComponent formValue={salesOrder} name={'SALES_ORDER'} />
          </div>
        }

      </div>
      <div className='mt-5 bg-white shadow'>
        {salesOrder.status === 'sales_order' && <Flex className='border-b m-0' justify='flex-end'>
          <SmartButton icon={<TbTruckDelivery size={'1.4rem'} />} number={0} text={'Delivery'} className='border-s-2' />
        </Flex>}
        <Form
          form={form}
          className='p-3'
          labelAlign='left'
          labelCol={{ span: 7 }}
          initialValues={salesOrder.number ? salesOrder :
            { shipping_policy: 'asap' }
          }
          variant='borderless'
          disabled={salesOrder.status === 'purchase_order' ? true : false}
        >
          <Row>
            <Col md={{ span: 11 }}>
              <Form.Item label={'Customer'} name={'customer_id'} className='font-bold mb-1' required>
                <Select options={contacts.map(contact => ({ value: contact.id, label: contact.name, }))} className='font-normal' />
              </Form.Item>
              <Form.Item label={'Invoice Address'} name={'invoice_address'} className='font-bold mb-1' required>
                <Select options={contacts.map(contact => ({ value: contact.id, label: contact.name, }))} className='font-normal' />
              </Form.Item>
              <Form.Item label={'Delivery Address'} name={'delivery_address'} className='font-bold mb-1' required>
                <Select options={contacts.map(contact => ({ value: contact.id, label: contact.name, }))} className='font-normal' />
              </Form.Item>
              <Form.Item label={'Customer Reference'} name={'customer_reference'} className='font-bold mb-1' required>
                <Input type='text' className='input-outline-none font-normal' />
              </Form.Item>
            </Col>
            <Col md={{ span: 11, offset: 1 }}>
              <Form.Item label='Delivery Date' name={'delivery_date'} className='font-bold mb-1' required>
                <DatePicker showTime format={'YYYY-MM-DD HH:mm'} className='font-normal w-full' />
              </Form.Item>
              <Form.Item label='Delivery Route' name={'route_id'} className='font-bold mb-1' required>
                <Select options={routes.map(route => ({value: route.id, label: route.name}))} className='font-normal' />
              </Form.Item>
            </Col>
          </Row>
          <Tabs
            type='card'
            items={[
              {
                key: 1,
                label: 'Products',
                children:
                  <EditableTable
                    products={products}
                    taxes={taxes}
                    dataSource={productQuotations}
                    setDataSource={setProductQuotations}
                    addLine={addLine}
                    columns={(salesOrder.status === 'purchase_order' || salesOrder.status === 'received') ? poColumns : quotationProductColumns}
                    disabled={(salesOrder.status === 'purchase_order' || salesOrder.status === 'received') ? true : false}
                    apiDelete={removeProductLine}
                  />
              },
              {
                key: '2',
                label: 'Optional Products',
                forceRender: true,
                children:
                  <EditableTable
                    products={products}
                    dataSource={optionalProducts}
                    setDataSource={setOptionalProducts}
                    addLine={addOptionalProducts}
                    columns={optionalColumns}
                    disabled={(salesOrder.status === 'sales_order' || salesOrder.status === 'delivered') ? true : false}
                    apiDelete={removeOptionalLine}
                  />
              },
              {
                key: '3',
                label: 'Other Information',
                forceRender: true,
                children:
                  <>
                    <Row>
                      <Col md={{ span: 11 }}>
                        <Badge className="text-slate-500 text-sm bg-transparent	border-b-2 mb-3">Sales</Badge>
                        <Form.Item label='Salesperson' name={'salesperson_id'} className='font-bold mb-1' required>
                          <Select options={contacts.map(contact => ({ value: contact.id, label: contact.name }))} className='font-normal' />
                        </Form.Item>
                        <Form.Item label='Sales Team' name={'sales_team_id'} className='font-bold mb-1' required>
                          <Select options={teams.map(team => ({ value: team.id, label: team.name }))} className='font-normal' />
                        </Form.Item>
                        <Form.Item label='Online Payment' name={'online_payment'} className='font-bold mb-1' required valuePropName='checked'>
                          <Checkbox />
                        </Form.Item>
                      </Col>
                      <Col md={{ span: 11, offset: 1 }}>
                        <Badge className="text-slate-500 text-sm bg-transparent	border-b-2 mb-3">Tracking</Badge>
                        <Form.Item label='Source Document' name={'source_document'} className='font-bold mb-1' required>
                          <Input type='text' className='input-outline-none font-normal' />
                        </Form.Item>
                        {/* <Form.Item label='Oportunity' className='font-bold mb-1' required>
                          <Select options={[]} className='font-normal' />
                        </Form.Item>
                        <Form.Item label='Campaign' className='font-bold mb-1' required valuePropName='checked'>
                          <Select options={[]} />
                        </Form.Item>
                        <Form.Item label='Medium' className='font-bold mb-1' required valuePropName='checked'>
                          <Select options={[]} />
                        </Form.Item>
                        <Form.Item label='Source' className='font-bold mb-1' required valuePropName='checked'>
                          <Select options={[]} />
                        </Form.Item> */}
                      </Col>
                    </Row>
                    <Row>
                      <Col md={{ span: 11 }}>
                        <Badge className="text-slate-500 text-sm bg-transparent	border-b-2 mb-3">Delivery</Badge>
                        <Form.Item label='Shipping Policy' name={'shipping_policy'} className='font-bold mb-1' required>
                          <Select options={shipPolicy} className='font-normal' />
                        </Form.Item>
                      </Col>
                    </Row>
                  </>
              },
            ]}
          />
        </Form>
      </div>
    </div>
  )
}
export default SalesOrderChanges;